import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-8aeea4c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"0.2em"} }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { id: "formContent" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo p-mt-5 p-mb-3",
  alt: "app logo"
}, null, -1))
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "p-error" }
const _hoisted_9 = {
  key: 1,
  class: "p-error"
}
const _hoisted_10 = { class: "p-field" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = {
  key: 0,
  class: "p-error"
}
const _hoisted_13 = { class: "p-field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "formFooter" }, [
  /*#__PURE__*/_createElementVNode("table", { class: "table table-bordered" }, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
        /*#__PURE__*/_createElementVNode("small", null, "App Version V4.1.2")
      ])
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showProgress)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            style: {"height":"0.2em"}
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.authenticate(!_ctx.v$.$invalid)), ["prevent"])),
          class: "p-fluid p-p-3"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.v$.email.$model) + " ", 1),
              _createVNode(_component_InputText, {
                id: "email",
                modelValue: _ctx.v$.email.$model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.email.$model) = $event)),
                class: _normalizeClass({
                'p-invalid': _ctx.v$.email.$invalid && _ctx.submitted,
              }),
                "aria-describedby": "email-error"
              }, null, 8, ["modelValue", "class"]),
              _createElementVNode("label", {
                for: "email",
                class: _normalizeClass({
                'p-error': _ctx.v$.email.$invalid && _ctx.submitted,
              })
              }, "User Email*", 2)
            ]),
            (_ctx.v$.email.$error && _ctx.submitted)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.email.$errors, (error, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      id: "email-error",
                      key: index
                    }, [
                      _createElementVNode("small", _hoisted_8, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ]))
              : (
              (_ctx.v$.email.$invalid && _ctx.submitted) || _ctx.v$.email.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_ctx.v$.email.required.$message.replace("Value", "Email")), 1))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_Password, {
                id: "password",
                modelValue: _ctx.v$.password.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.password.$model) = $event)),
                class: _normalizeClass({
                'p-invalid': _ctx.v$.password.$invalid && _ctx.submitted,
              }),
                feedback: false
              }, null, 8, ["modelValue", "class"]),
              _createElementVNode("label", {
                for: "password",
                class: _normalizeClass({
                'p-error': _ctx.v$.password.$invalid && _ctx.submitted,
              })
              }, "Password*", 2)
            ]),
            (
              (_ctx.v$.password.$invalid && _ctx.submitted) ||
              _ctx.v$.password.$pending.$response
            )
              ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.v$.password.required.$message.replace("Value", "Password")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_Button, {
              type: "submit",
              label: "Sign In",
              icon: "pi pi-unlock",
              class: "p-button-primary p-button-raised p-button-rounded"
            })
          ])
        ], 32),
        _hoisted_14
      ])
    ])
  ], 64))
}